import { render } from "./widget-contract-user-attributes.vue?vue&type=template&id=bc5b09aa"
import script from "./widget-contract-user-attributes.vue?vue&type=script&setup=true&lang=js"
export * from "./widget-contract-user-attributes.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/widgets/widget-contract-user-attributes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bc5b09aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bc5b09aa', __exports__)) {
    api.reload('bc5b09aa', __exports__)
  }
  
  module.hot.accept("./widget-contract-user-attributes.vue?vue&type=template&id=bc5b09aa", () => {
    api.rerender('bc5b09aa', render)
  })

}


export default __exports__